import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import IntelligencePageLayout from '@fuww/library/src/Layouts/IntelligencePage';
import Table, {
  TableBody, TableContainer, TableRow, SocialMediaValueCell,
  SocialMediaTableCells,
} from '@fuww/library/src/Table';
import messages from '../lib/messages.json';
import Layout from '../components/Layout';
import Head from '../components/Head';
import Hero from '../components/Hero';
import tiktokFashionIndex
  from '../data/staticPages/i/tiktok-fashion-index.json';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import FashionIndexTableHead from '../components/FashionIndex/TableHead';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/WiKShi-kHbkJ2tXVGE55iNJymQhCzan7Fas3_XG91WU/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/P-sX5qvHPnjI7QNCKSh4TNModDGY227k5yKtspfDMmA/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/xKOyAJ54W_drnpY-QVRRakVWoYulqM9nyCqbrLwYCmo/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX21vYmlsZS5qcGc',
  ],
  desktop: [
    'https://r.fashionunited.com/1ZPFOHsNY2g7OJ5o33M1KCShj0-bcwIRTJwyKMXeTrw/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/VXopspApEUvUk6qO_JgrAm9dp7M5e-0QIqcZSk8Le7Q/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/1Lopfwa648DLa05Yxk1ggdjVYYZJbH3H_vC9SrFKW-8/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/BBCBuELgsib_uzH8YW59GI0Wl8YYzBlLjdY8m2UCxG4/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdGlrdG9rX2Zhc2hpb25faW5kZXhfYmFubmVyX2Rlc2t0b3AuanBn',
  ],
};

const TikTokFashionIndexPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'tiktok-fashion-index',
    'tiktokFashionIndex',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['tiktokFashionIndex.title'])}
        description={intl.formatMessage(
          messages['tiktokFashionIndex.description'],
        )}
      />
      <IntelligencePageLayout
        breadcrumbs={breadcrumbs}
        description={
          intl.formatMessage(messages['tiktokFashionIndex.description'])
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages['tiktokFashionIndex.table.ariaLabel'])}
              >
                <FashionIndexTableHead alignRight />
                <TableBody>
                  {tiktokFashionIndex.map(({ brand, likes, link }, index) => (
                    <TableRow key={brand}>
                      <SocialMediaTableCells
                        index={index + 1}
                        link={link}
                        value={brand}
                      />
                      <SocialMediaValueCell value={likes} alignRight />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages['tiktokFashionIndex.source']),
            }}
            />
          </>
        )}
        subTitle={intl.formatMessage(messages['tiktokFashionIndex.subTitle'])}
        title={intl.formatMessage(messages['tiktokFashionIndex.title'])}
      />
    </>
  );
};

TikTokFashionIndexPage.getLayout = (page: ReactElement) => (
  <Layout header={(
    <Hero
      imageUrls={headerImageUrls}
      alt="TikTok Fashion Index"
    />
  )}
  >
    {page}
  </Layout>
);

TikTokFashionIndexPage.getInitialProps = redirectRouteToDomain(
  'tiktok-fashion-index',
);

export default TikTokFashionIndexPage;
